import React from 'react';
import PropTypes from 'prop-types';
import StatusPill from './pill/StatusPill';

const VARIANT_CONFIG = {
  pending_draft: {
    label: 'Draft',
    tone: 'neutral',
    title: 'A draft version of this workflow is pending publication.',
  },
  // The three lifecycle states themselves, for the editor, which until now showed none of them
  // and so could not distinguish the workflow that is live from the draft that replaces it.
  draft: {
    label: 'Draft',
    tone: 'neutral',
    title: 'Not live. Publish it to put it in front of field engineers.',
  },
  published: {
    label: 'Published',
    tone: 'success',
    title: 'Live. Field engineers can be assigned this workflow.',
  },
  deprecated: {
    label: 'Deprecated',
    tone: 'quiet',
    title: 'Replaced by a newer published version.',
  },
};

// This one sits beside the lifecycle word it qualifies, which is why it is inline-sized — and
// why it was already the closest thing in the app to the rule the rest now follows.
//
// `title` overrides the per-variant default. The editor uses it to say which version is live
// ("Published version v4") rather than repeating what a draft is, which the badge's own word
// already says.
export default function WorkflowLifecycleBadge({ variant, className, title }) {
  const config = VARIANT_CONFIG[variant];
  if (!config) return null;

  return (
    <StatusPill
      tone={config.tone}
      size="inline"
      title={title || config.title}
      className={className}
    >
      {config.label}
    </StatusPill>
  );
}

WorkflowLifecycleBadge.propTypes = {
  variant: PropTypes.oneOf(['pending_draft', 'draft', 'published', 'deprecated']).isRequired,
  className: PropTypes.string,
  title: PropTypes.string,
};

WorkflowLifecycleBadge.defaultProps = {
  className: '',
  title: '',
};
